// generated from 549 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const createdAtFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("created_at_filter"),
  comparison_key: z.enum([
    "3", // 332 (60.47%)
    "4", // 108 (19.67%)
    "6", // 55 (10.02%)
    "5", // 54 (9.84%)
  ]),
  display_name: z.string(),
  // undefined: 71 (12.93%), defined 478 (87.07%)
  raw_value: z
    .union([
      // number samples: 129 (26.99%)
      // integer: 121 (93.80%)
      // avg: 49.85, min: 0.041666666666666664, max: 396
      z.number().nonnegative(),
      // string samples: 349 (73.01%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 163 (29.69%)
    // integer: 147 (90.18%)
    // avg: 57.81, min: 0.004166666666666667, max: 1099
    z.number().nonnegative(),
    // string samples: 386 (70.31%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
